module.exports = __webpack_public_path__ + "img/logo_indofarma.539ca41e.png";